import {
  Display,
  DisplayDurationUnit,
  DisplayPrecision,
} from '@fullstory/proto/fs/services/webber/frontend/display';

export const MEDIAN_PERCENTILE = 50;

export const TIME_TO_COMPLETE_DISPLAY: Display = {
  displayPrecision: DisplayPrecision.PRECISION_2,
  displayDuration: {
    autoscale: true,
    unit: DisplayDurationUnit.DURATION_SEC,
  },
};
